module.exports = __webpack_public_path__ + "media/images/payment-3-653382db0039b6276b25c035d4ec4f54.png";